/** ຄ່າ status ຈາກ `credit_invoices.status` (DB enum) */
export type CreditInvoiceStatusValue =
  | "pending"
  | "partial"
  | "paid"
  | "overdue"
  | "cancelled";

const LABELS: Record<CreditInvoiceStatusValue, string> = {
  pending: "ລໍຖ້າຊຳລະ",
  partial: "ຊຳລະບາງສ່ວນ",
  paid: "ຊຳລະຄົບແລ້ວ",
  overdue: "ເກີນໄລກຳນົດ",
  cancelled: "ຍົກເລີກ",
};

export function formatCreditInvoiceStatusLa(status: string): string {
  if (status in LABELS) {
    return LABELS[status as CreditInvoiceStatusValue];
  }
  return status;
}

export type CreditInvoiceStatusBadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline";

export type CreditInvoiceStatusBadgeStyle = {
  variant: CreditInvoiceStatusBadgeVariant;
  className?: string;
};

export function creditInvoiceStatusBadgeStyle(
  status: string,
): CreditInvoiceStatusBadgeStyle {
  switch (status as CreditInvoiceStatusValue) {
    case "paid":
      return {
        variant: "outline",
        className:
          "border-emerald-500/40 bg-emerald-500/10 font-normal text-emerald-800",
      };
    case "partial":
      return {
        variant: "outline",
        className: "border-sky-500/40 bg-sky-500/10 font-normal text-sky-800",
      };
    case "pending":
      return {
        variant: "outline",
        className:
          "border-amber-500/40 bg-amber-500/10 font-normal text-amber-900",
      };
    case "overdue":
      return {
        variant: "destructive",
        className: "font-normal",
      };
    case "cancelled":
      return {
        variant: "secondary",
        className: "font-normal text-muted-foreground",
      };
    default:
      return { variant: "outline", className: "font-normal" };
  }
}
